import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import MenuEntryTable from '@cms/components/tables/menu-entry-table/menu-entry-table.vue';

@Component({
  name: 'bpc-menu-entry',
  components: {
    'bpc-menu-entry-table': MenuEntryTable,
  },
})
export default class MenuEntries extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
